import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'
import { cardsModule } from '../utils/store-accessor'
import { entityTypeFromBrand } from '../utils/brand-helper'
import { triggerManualAbTestExposure } from '../libraries/statsig'
import { Card } from '../store/modules/CardsModule'

enum OnboardingExperimentTestVariant {
    CURRENT = 'current',
    ON_PUBLISHING = 'on_publishing',
}

export default defineComponent({
    name: 'WithOnboarding',
    computed: {
        ...mapGetters({
            isLoggedIn: 'user/isLoggedIn',
            isAdmin: 'user/isAdmin',
            onboarding: 'document/onboarding',
            onboardingComplete: 'user/onboardingComplete',
            roleAndMarketingCollection: 'abtests/roleAndMarketingCollection',
        }),
        user(): any {
            return this.$store.state.user as any
        },
        cards(): Card[] {
            return cardsModule.cards
        },
        useCurrentOnboarding(): boolean {
            return this.roleAndMarketingCollection === OnboardingExperimentTestVariant.CURRENT
        },
        usePublishingOnboarding(): boolean {
            return this.roleAndMarketingCollection === OnboardingExperimentTestVariant.ON_PUBLISHING
        },
        showProgressSteppers(): boolean {
            return this.useCurrentOnboarding && this.onboarding
        },
        shouldShowOnboardingModal(): boolean {
            if (!this.isLoggedIn || this.isAdmin || this.onboardingComplete) {
                return false
            }

            return !this.user?.user?.trialed && !this.cards.length
        },
        roleAndMarketingCollectionTestName(): string {
            return `${entityTypeFromBrand()}_role_and_marketing_collection`
        },
        shouldCollectRoleAndMarketing(): boolean {
            return this.user?.user?.request_no_email === null || this.user?.user?.occupation === null
        },
        showPublishingOnboarding(): boolean {
            return this.shouldCollectRoleAndMarketing && this.usePublishingOnboarding
        },
    },
    methods: {
        showOnboardingModal() {
            this.$bvModal.show('onboarding-modal')
        },
        recordRoleAndMarketingCollectionExposure() {
            triggerManualAbTestExposure(this.roleAndMarketingCollectionTestName)
        },
    },
})
